module.exports = __webpack_public_path__ + "img/gentlemen-club-collection-20.97584e6d.png";